import { AuthFlowPage } from '../components/AuthFlowPage'

export default function LoginPage() {
  return <AuthFlowPage kind="login" />
}
